import routes from '../../config/routes';

type RouteLike = {
  path?: string;
  component?: string;
  routes?: RouteLike[];
};

export const NO_MENU_PATH = '/user/no-menu';

const flattenPageRoutePaths = (items: RouteLike[]): Set<string> => {
  const paths = new Set<string>();

  const visit = (routeItems: RouteLike[]) => {
    routeItems.forEach((item) => {
      if (item.path && item.component) {
        paths.add(item.path);
      }
      if (item.routes?.length) {
        visit(item.routes);
      }
    });
  };

  visit(items);
  return paths;
};

const pageRoutePaths = flattenPageRoutePaths(routes as RouteLike[]);
const parentMenuChildren: Record<string, string[]> = {
  '/project-table': [
    '/project-table/list',
    '/project-table/developer',
    '/project-table/product',
  ],
  '/product-analysis': [
    '/product-analysis/overview',
    '/product-analysis/project',
    '/product-analysis/funnel',
    '/product-analysis/funnel/overview',
    '/product-analysis/funnel/workbench',
    '/product-analysis/funnel/diagnosis',
    '/product-analysis/funnel/cohort',
    '/product-analysis/funnel/path',
    '/product-analysis/funnel/evidence',
    '/product-analysis/funnel/issues',
    '/product-analysis/funnel/snapshot',
    '/product-analysis/admob',
    '/product-analysis/firebase',
    '/product-analysis/firebase-binding',
    '/product-analysis/reconcile',
    '/product-analysis/tracking',
    '/product-analysis/config',
    '/product-analysis/tasks',
  ],
  '/product-analysis/funnel': [
    '/product-analysis/funnel/overview',
    '/product-analysis/funnel/workbench',
    '/product-analysis/funnel/diagnosis',
    '/product-analysis/funnel/cohort',
    '/product-analysis/funnel/path',
    '/product-analysis/funnel/evidence',
    '/product-analysis/funnel/issues',
    '/product-analysis/funnel/snapshot',
  ],
};

export const isDefinedMenuUser = (user?: API.CurrentUser) =>
  user?.loginMode === 'operation' && user.user_type === 'define';

export const getDefinedMenuPaths = (user?: API.CurrentUser) => {
  const paths = new Set(
    (user?.menus ?? []).filter((path): path is string => !!path),
  );
  Object.entries(parentMenuChildren).forEach(([parent, children]) => {
    if (paths.has(parent)) {
      children.forEach((path) => {
        paths.add(path);
      });
    }
  });
  return paths;
};

export const getFirstAllowedDefinedMenuPath = (user?: API.CurrentUser) => {
  const menus = user?.menus ?? [];
  for (const path of menus) {
    if (pageRoutePaths.has(path)) return path;
    const firstChild = parentMenuChildren[path]?.find((child) =>
      pageRoutePaths.has(child),
    );
    if (firstChild) return firstChild;
  }
  return undefined;
};

export const isAllowedDefinedMenuPath = (
  pathname: string,
  user?: API.CurrentUser,
) => {
  if (!isDefinedMenuUser(user)) {
    return true;
  }
  if (pathname === NO_MENU_PATH) {
    return true;
  }
  return (
    getDefinedMenuPaths(user).has(pathname) && pageRoutePaths.has(pathname)
  );
};
